import type { HealthUnitType } from '@/modules/company/Units/unitType'
import type { HealthUnitPinMeta } from './PinSuggestionRequests'

export enum PhoneType {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
  PARTICULAR = 'PARTICULAR',
  OTHER = 'OTHER'
}

export type CreateHealthUnit = {
  avatarUrl?: string
  email?: string
  cnpj?: string
  profile?: string
  quantityColaborators?: number
  generalManager?: string
  technicalManager?: string
  name?: string
  linkWaze?: string
  reachRadius?: number
  operationalGroup?: string | null
  type?: HealthUnitType
  /** Origem/justificativa do pino gravadas na auditoria de geolocalização. */
  pinMeta?: HealthUnitPinMeta
  mainPhone?: {
    phoneNumber: string
    phoneType: PhoneType
  }
  mainAddress?: {
    postalCode: string
    state: string
    city: string
    street: string
    number: string
    neighborhood: string
    complement?: string
    latitude: number
    longitude: number
  }
}

export type DeactiveHealthUnit = {
  isActive?: boolean
}

export type FiltersHealthUnits = {
  search?: string
  ufs?: string
  companies?: string
  limit?: number
  offset?: number
  page?: number
  // companyId: number
}
